import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '@edx/frontend-platform/i18n';
import { useDispatch } from 'react-redux';
import BookmarkOutlineIcon from './BookmarkOutlineIcon';
import BookmarkFilledIcon from './BookmarkFilledIcon';
import { removeBookmark, addBookmark } from './data/thunks';

export default function BookmarkButton({
  isBookmarked, isProcessing, unitId,
}) {
  const dispatch = useDispatch();
  const toggleBookmark = useCallback(() => {
    if (!isProcessing) {
      if (isBookmarked) {
        dispatch(removeBookmark(unitId));
      } else {
        dispatch(addBookmark(unitId));
      }
    }
  }, [isProcessing, isBookmarked, unitId]);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus
    <div className="btn-bookmark" role="button" onClick={toggleBookmark}>
      {isBookmarked ? (
        <div>
          <BookmarkFilledIcon className="mr-2" />
          <FormattedMessage
            id="unit.bookmark.button.remove.bookmark"
            defaultMessage="Bookmarked"
            description="The button to show a page is bookmarked and the button to remove that bookmark"
          />
        </div>
      ) : (
        <div>
          <BookmarkOutlineIcon className="mr-2" />
          <FormattedMessage
            id="unit.bookmark.button.add.bookmark"
            defaultMessage="Bookmark this page"
            description="The button to bookmark a page"
          />
        </div>
      )}
    </div>
  );
}

BookmarkButton.propTypes = {
  unitId: PropTypes.string.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  isBookmarked: PropTypes.bool,
};

BookmarkButton.defaultProps = {
  isBookmarked: false,
};
